import frameUrl from "@/assets/icons/productDetails/product-card-frame.svg";

export const getImageContainerStyles = (
  isSmallMobile: boolean,
  isMobile: boolean,
  isTablet: boolean,
  isDesktop: boolean
) => ({
  flexShrink: 0,
  width: isSmallMobile
    ? 257
    : isMobile
      ? 312
      : isTablet
        ? 320
        : isDesktop
          ? 480
          : 500,
  height: isSmallMobile
    ? 260
    : isMobile
      ? 307
      : isTablet
        ? 317
        : isDesktop
          ? 476
          : 490,
  pd: 1,
  mx: "auto",
  mb: { xs: 5, md: "auto" },
  mt: { xs: 0, md: "auto" },
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  boxSizing: "border-box",
  borderRadius: "20px",
  backgroundImage: `url(${frameUrl})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
});


export const getImageWrapperStyles = (isSmallMobile: boolean,
  isMobile: boolean,
  isTablet: boolean,
  isDesktop: boolean) => ({
    flexShrink: 0,
    width: isSmallMobile
      ? 160
      : isMobile
        ? 180
        : isTablet
          ? 190
          : isDesktop
            ? 220
            : 240,
    height: isSmallMobile
      ? 160
      : isMobile
        ? 180
        : isTablet
          ? 190
          : isDesktop
            ? 220
            : 240,
    boxSizing: "border-box",
  })

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
}

export const reviewCardAvatarStyles = {
  width: { xs: 32, md: 40 },
  height: { xs: 32, md: 40 },
  alignSelf: "start",
  mt: 0.5,
}